import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Navbar />

      <main className="flex-1 py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading font-extrabold text-4xl text-slate-900 mb-8">Privacy Policy</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-600 mb-6">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            
            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">1. Information We Collect</h2>
            <p className="text-slate-600 mb-4">
              When you use JobMatch, we collect information you provide directly to us, such as:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Account information (name, email address)</li>
              <li>Resume content (for analysis purposes only)</li>
              <li>Job descriptions you submit</li>
              <li>Payment information (processed securely by Stripe)</li>
            </ul>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="text-slate-600 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Provide and improve our resume analysis service</li>
              <li>Process your subscription payments</li>
              <li>Send you service-related communications</li>
              <li>Respond to your requests and support needs</li>
            </ul>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">3. Data Security</h2>
            <p className="text-slate-600 mb-4">
              We implement industry-standard security measures to protect your data. Resume content is processed 
              for analysis and is not stored permanently or shared with third parties. We use SSL encryption 
              for all data transmission.
            </p>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">4. Data Retention</h2>
            <p className="text-slate-600 mb-4">
              Your analysis history is retained in your account until you delete it or delete your account. 
              You can delete your account at any time, which will remove all associated data.
            </p>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">5. Your Rights</h2>
            <p className="text-slate-600 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Access your personal data</li>
              <li>Delete your account and all associated data</li>
              <li>Export your analysis history</li>
              <li>Opt out of marketing communications</li>
            </ul>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">6. Contact Us</h2>
            <p className="text-slate-600 mb-4">
              If you have questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:privacy@jobmatch.app" className="text-slate-900 underline">privacy@jobmatch.app</a>
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
